import { rootMargin } from '@helpers/animate';
import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
import useMedia from '@hooks/useMedia';
import TestimonialCard from '@stories/Components/Cards/TestimonialCard/TestimonialCard';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import { BackgroundVariant } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './TestimonialCarousel.styles';
const TestimonialCarousel = (props) => {
    const [containerRef, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    const paddingOffset = useMedia([until(Device.Desktop)], [16], 135);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(S.Container, { id: props.anchorId, ref: containerRef, translations: props.translations, variant: props.backgroundVariant
                ? props.backgroundVariant
                : BackgroundVariant.Blue, "data-animate": inView, "data-background-box": props.showBackgroundBox },
            React.createElement(HeadingSummaryBlock, { ...props }),
            React.createElement(CarouselProvider, { count: props.items.length, paddingOffset: paddingOffset },
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { trackMutations: true }, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(TestimonialCard, { ...item, variant: props.cardVariant ?? BackgroundVariant.Blue })))))),
                React.createElement(Pagination, { translations: props.translations })))));
};
export default withMotion(TestimonialCarousel);
